import React, { createContext, useContext } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

import { useVirtualKeyboard } from './hooks/use-virtual-keyboard';
import { IVirtualKeyboardContext } from './types';

export const VirtualKeyboardContext = createContext({} as IVirtualKeyboardContext);

export const VirtualKeyboardProvider = ({ children }: IBaseProps) => {
  const value = useVirtualKeyboard();

  return (
    <VirtualKeyboardContext.Provider value={value}>{children}</VirtualKeyboardContext.Provider>
  );
};

export const useVirtualKeyboardContext = () => useContext(VirtualKeyboardContext);

export default VirtualKeyboardContext.Consumer;
